export const REGEX = {
  CUID: /^c[0-9a-z]{24}$/,
  EMAIL:
    /^(?!\.)(?!.*\.$)(?!.*\.\.)(?!.*[._-]$)(?!.*[._-]{2})[a-zA-Z0-9._-]+@[a-zA-Z0-9]+\.+[a-zA-Z]{2,}$/,
  USER_NAME: /^[A-Za-z]+( [A-Za-z]*)*$/,
  LICENSE_PLATE_NUMBER:
    /^(?!.*[!@#$%^&*()+=[\]{}|;':",.<>?])(?!.*-{2,})[^\p{P}-][\p{L}\p{N}-]*[^\p{P}-]$/u,
};
